import { Flow } from 'vivaa-api';

export const FLOW_KIND_CONSTANTS: Record<
  Flow.FlowKind,
  { label: string; pluralLabel: string; basePath: string }
> = {
  [Flow.FlowKind.Base]: {
    label: 'Flow',
    pluralLabel: 'Flows',
    basePath: '/agents/flows',
  },
  [Flow.FlowKind.Skill]: {
    label: 'Skill',
    pluralLabel: 'Skills',
    basePath: '/agents/skills',
  },
  [Flow.FlowKind.FlowTemplate]: {
    label: 'Flow Template',
    pluralLabel: 'Flow Templates',
    basePath: '/agents/flows/create',
  },
};
